import * as React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import styles from './popular.module.scss';
import { List } from 'office-ui-fabric-react/lib/List';
import { Flex } from '@fluentui/react-northstar';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { Story } from '../../model';
import StoryItem from './storyItem';
import { getStory } from '../../store/Story/actions';
import { useDispatch } from 'react-redux';
import Loader from '../../components/Loader';
import envConfig from '../../config';


const PopularContent = ({
    onSelectionChange
}: {
    onSelectionChange?: (files: {
        fileId: number;
        storyId: number;
    }[]) => void;
}) => {
    const dispatch = useDispatch();
    const {
        stories: fromApi,
        loading
    } = useTypedSelector((state: ApplicationState) => state.popularStories);

    const {
        stories: cacheStories
    } = useTypedSelector((state: ApplicationState) => state.story);

    const [stories, updateStories] = React.useState(fromApi);

    const {
        currentMeeting
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    const [selectedStoryIds, updateSelectedStortIds] = React.useState([] as number[]);
    const notifyStorySelectionChange = (ids: number[]) => {
        const dataToSend: {
            fileId: number;
            storyId: number;
        }[] = [];
        ids.forEach((id) => {
            const currentStory = cacheStories[id];
            if (currentStory) {
                (currentStory.files || []).forEach((item: any) => {
                    dataToSend.push({
                        fileId: item.id,
                        storyId: currentStory.perm_id
                    });
                });
            }
        });
        onSelectionChange && onSelectionChange(dataToSend)
    };
    const onStoryClick = (storyId: number) => {
        if (selectedStoryIds.indexOf(storyId) >= 0) {
            const tmpIds = selectedStoryIds.filter(c => c !== storyId);
            updateSelectedStortIds(tmpIds);
            notifyStorySelectionChange(tmpIds);
        } else {
            const tmpIds = [...selectedStoryIds, storyId];
            updateSelectedStortIds(tmpIds);
            notifyStorySelectionChange(tmpIds);
        }
        updateStories([...stories]);

    }
    React.useEffect(() => {
        stories.forEach((story) => {
            if (!cacheStories[story.permId]) {
                dispatch(getStory(story.permId));
            }

        });
    }, [stories])

    const onStoryRenderCell = (item: Story | undefined): JSX.Element => {

        if (!item) {
            return <></>
        }
        const detailStory = cacheStories[item.permId]
        if (!detailStory) {
            return <></>;
        }
        const cache = {
            ...item,
            ...detailStory
        } as unknown as Story;

        let isFound = false;
        if (currentMeeting.meetingContents)
         isFound = !!currentMeeting.meetingContents.find(c => c.storyId === item.permId);
        return <StoryItem disable={isFound} checked={!!selectedStoryIds.find(c => c === item.permId) || isFound} onItemClick={onStoryClick} {...cache} />
    };

    React.useEffect(() => {
        updateStories(fromApi);
    }, [fromApi]);
    const filterStories = (stories || []).filter((item: any) => {
        const detailStory = cacheStories[item.permId];
        if(!detailStory) {
            return true;
        }
        const files = detailStory.files.filter((c: any) => envConfig.invalidCategory.indexOf(c.category) < 0) as unknown as File[];
        item.files = files as File[];
        return files.length > 0;
        //currentStory.files.filter(c => envConfig.invalidCategory.indexOf(c.category) < 0) as unknown as File[];
    })
    return (
        <Flex column className={styles.root}>
            {loading && <div className={styles.loader}><Loader /></div>}
            <h1>Popular</h1>
            <Stack.Item grow={1} className={styles.list}>
                <List items={filterStories} onRenderCell={onStoryRenderCell} />
            </Stack.Item>
        </Flex>
    );

};
export default PopularContent;